import type { FaireProductEntity } from "../../entity_types/product";

export const p_gbnp9dbmch: FaireProductEntity = {
  token: "p_gbnp9dbmch",
  type: "product",
  name: "Cushion Cut Bezel Diamond Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3e1ae5b29402b072e2771f4f8dc350aa0061b5cc4166d6e3d3a59b79a3187d91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1337cde988f4132dce32263c05cc426c5de96fd1017d1a6c13558dbacebaecbd.jpeg",
    "https://cdn.faire.com/fastly/a9a3f777260abb8e51683453c35345e134b61b89721c9960a002dd7bf406a407.jpeg",
    "https://cdn.faire.com/fastly/425666b33db6a6e719b77944666f23e89e2d6d455c03e6b0bc232459fa0699e0.jpeg",
    "https://cdn.faire.com/fastly/6a55ef028058abfa09d896499303de9bf21b2247552acd6649783c20095c2dbb.jpeg",
  ],
  priceDollars: 14.94,
  description:
    'Enhance your style with this exquisite cushion cut diamond necklace. Its elegant design and sparkling shine make it a must-have accessory for any outfit. Add it to your jewelry collection for a touch of sophistication.\n\nDimensions: Approximately 16" w/ 2" extender\n\n18k gold plated brass\n\nLead and nickel free\n\nMade in China',
  tags: [],
  msrpDollars: 29.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:41.622Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
